import './components/neti-config-icon';
import './components/neti-powered-by';
import './components/neti-ior-settings-icon';
import './components/cart-listing';
import './components/context-menu-plugin';
import './components/config-links';
import './extensions/sw-customer';
import './extensions/sw-extension-card-base';
import './module/incomplete-order-reminder-email-log';
import './module/cart';
import './snippets';

Shopware.Module.register('neti-incomplete-order-reminder-customer-tab', {
    routeMiddleware(next, currentRoute) {
        if ('sw.customer.detail' === currentRoute.name) {
            currentRoute.children.push({
                name: 'neti.incomplete_order_reminder.customer.detail.open_carts',
                path: '/sw/customer/detail/:id/incomplete-orders',
                component: 'neti-incomplete-order-reminder-customer-tab',
                meta: {
                    parentPath: 'sw.customer.index'
                }
            });
        }
    }
});
